/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@atlaskit/css';
import Lozenge from '@atlaskit/lozenge/lozenge';
import type { SemanticColor } from '@atlaskit/lozenge/types';

import type { Status } from '../../../api/useIssueSearchQuery/types';

export const IssueStatusNode: ({ status }: { status: Status }) => JSX.Element | null = ({
	status,
}: {
	status: Status;
}) => {
	if (!status?.name || !status?.statusCategory.statusCategoryId) {
		return null;
	}

	let appearance: SemanticColor = 'neutral';
	switch (status.statusCategory.statusCategoryId) {
		case '2':
			appearance = 'neutral';
			break;
		case '4':
			appearance = 'information';
			break;
		case '3':
			appearance = 'success';
			break;
	}

	return (
		<Lozenge appearance={appearance} isBold>
			{status.name.toUpperCase()}
		</Lozenge>
	);
};
